import {LitElement, html} from 'lit';
import {property, customElement} from 'lit/decorators.js';
import {Service} from '../../service/service.js';
import {DataManagementService} from '../../service/datamanagement/dataManagementService.js';
import {UnitService} from '../../service/unit/unitService.js';
import {ElementUtil} from '../../utils/elementUtil.js';
import {TimeUtil} from '../../utils/timeUtil.js';
import {StringUtil} from '../../utils/stringUtil.js';
import {ImportUtil} from '../../utils/importUtil.js';
import {RoutingService} from '../../service/routing/routingService.js';
import {BaseComponent} from '../basecomponent.js';
import {DataTools} from './dataTools.js';


/* global customElements */
class TripSheetGrid extends BaseComponent {
	
	static get properties() {
		return {			
		};
	}
	
	constructor() {
		super();
		
		var tripsheetGrid = this;
		setTimeout(function(){
			tripsheetGrid.init();
		});
	}
	
	render() {	
		return html`
			<slot></slot>		
		`;
	}
	
	init() {
		var tripsheetGrid = this;
	
		var toolbar = ElementUtil.create({
			tag: 'dl-toolbar',
			slot: 'toolbar',
			theme: 'spacing',
			children: [
				{
					tag: 'vaadin-button',
					itemid: 'refresh',
					'class': 'spacer-toolbar-item',
					children:[
						ElementUtil.makeIcon('vaadin:refresh', ' Refresh')
					], 
					listeners: {
						click: function() {
							tripsheetGrid.actionRefresh();
						}
					}
				},
				{
					tag: 'span',
					innerHTML: '|'
				},
				{
					tag: 'dl-action-button',
					itemid: 'add',
					theme: 'primary',
					'class': 'spacer-toolbar-item',					
					permissions: ['TRIP_SHEETS:WRITE'],
					children:[
						ElementUtil.makeIcon('vaadin:plus', ' Add')						
					],
					listeners: {
						click: function() {
							actionAddEdit();
						}
					}					
				},
				{
					tag: 'dl-action-button',
					itemid: 'edit',
					'class': 'spacer-toolbar-item',
					disabled: true,	
					permissions: ['TRIP_SHEETS:WRITE'],
					children:[
						ElementUtil.makeIcon('vaadin:edit', ' Edit')						
					],
					listeners: {
						click: function() {
							actionAddEdit(grid.selectedItems[0]);
						}
					}					
				},
				{
					tag: 'span',
					innerHTML: '|'
				},
				{
					tag: 'dl-action-button',
					itemid: 'details',
					'class': 'spacer-toolbar-item',
					disabled: true,	
					permissions: ['TRIP_SHEETS:READ'],
					children:[
						ElementUtil.makeIcon('vaadin:notebook', ' Details')						
					],
					listeners: {
						click: function() {
							actionDetails(grid.selectedItems[0]);
						}
					}					
				},				
				{
					tag: 'div',
					style: 'float: right;',
					children:[						
						{
							tag: 'dl-action-button',
							itemid: 'delete',
							'class': 'spacer-toolbar-item',	
							theme: 'error primary',
							permissions: ['TRIP_SHEETS:DELETE'],							
							children:[
								ElementUtil.makeIcon('vaadin:trash', ' Delete')						
							],
							listeners: {
								click: function() {
									actionDelete(grid.selectedItems[0]);
								}
							}							
						}
					]
				}											
			]
		});		
		
		var grid = ElementUtil.create({
			tag: 'vaadin-grid',
			theme: 'wrap-cell-content row-stripes column-borders',
			'column-reordering-allowed': '',
			style: 'height: 100%;',			
			slot: 'primary',
			defaults: {
				tag: 'vaadin-grid-sort-column',
				resizable: true,
				listeners: {
					'direction-changed' : function(event) {
						if (event.detail && event.detail.value) {
							grid.currentSortField = event.target.path;
							grid.currentSortDirection = event.detail.value.toUpperCase();
							pagingToolbar.loadCurrentPage();
						}
					}
				}
			},			
			children: [				
				{						
					path: 'tractorRefNo',
					header: 'Tractor Ref No',
					width: '7em'
				},
				{						
					path: 'entryTypeDescription',
					header: 'Type',
					width: '7em'
				},
				{						
					path: 'tripSheetRefNo',
					header: 'Sheet Ref No',
					width: '7em'
				},
				{						
					path: 'driverRefNo',
					header: 'Driver Ref No',
					width: '7em'
				},				
				{						
					path: 'beginDts',
					header: 'Begin Date',
					width: '7em',					
					renderer: function(root, column, rowData) {
						var date = TimeUtil.parseDate(rowData.item.beginDts);						
						root.innerHTML = TimeUtil.formatDateStandard(date);						
					}
				},
				{						
					path: 'endDts',
					header: 'End Date',
					width: '7em',					
					renderer: function(root, column, rowData) {
						var date = TimeUtil.parseDate(rowData.item.endDts);						
						root.innerHTML = TimeUtil.formatDateStandard(date);						
					}
				},
				{						
					path: 'initialOdometer',
					header: 'Initial Odometer',
					width: '7em'
				},
				{						
					path: 'distanceUom',
					header: 'Distance Units',
					width: '7em'
				},
				{						
					path: 'tripStatusDescription',
					header: 'Status',
					width: '7em'				
				},
				{						
					path: 'updateUser',
					header: 'Update User',
					hidden: true,
					width: '7em'
				},
				{						
					path: 'updateDts',
					header: 'Update Date',
					width: '7em',
					hidden: true,
					renderer: function(root, column, rowData) {
						var date = TimeUtil.parseDate(rowData.item.updateDts);						
						root.innerHTML = TimeUtil.formatDateStandard(date);						
					}
				}
			],
			listeners: {
				'active-item-changed': function(event) {
					const item = event.detail.value;					
					
					grid.selectedItems = item ? [item] : [];
					if (grid.selectedItems.length > 0) {
						ElementUtil.query(toolbar, 'edit').disabled = false;
						ElementUtil.query(toolbar, 'details').disabled = false;						
						ElementUtil.query(toolbar, 'delete').disabled = false;						
					} else {
						ElementUtil.query(toolbar, 'edit').disabled = true;
						ElementUtil.query(toolbar, 'details').disabled = true;						
						ElementUtil.query(toolbar, 'delete').disabled = true;
					}
				}
			}
		});	
		
		var exportToolbar = ElementUtil.create({
			tag: 'dl-export-toolbar',
			itemid: 'trip-sheets',
			children: [			
			],
			listeners: {
				ready: function() {
					exportToolbar.updateGrid(grid);
				},
				'click-detail': function() {
					DataManagementService.getDistanceSummaryService().exportTripSheets(grid.currentFilter);					
				}
			}
		});
		
		var pagingToolbar = ElementUtil.create({
			tag: 'dl-paging-toolbar',
			slot: 'footer',
			pageSize: 100,
			postinit: function(element) {
				element.grid = grid;
				element.loader = function(backingGrid, pageNumber, pagingToolbar) {
					var pageRange = pagingToolbar.pullRange();
					var loadMask = grid.showLoading();
										
					var loadData = function() {
									
						var startFilterDts = TimeUtil.startOfDayCompanyTime(ElementUtil.query(tripsheetGrid.toolbarFilter, 'filterStartDate').value);										
						var endFilterDts =  TimeUtil.endOfDayCompanyTime(ElementUtil.query(tripsheetGrid.toolbarFilter, 'filterEndDate').value);		
									
						grid.currentFilter = {
							offset: pageRange.offset,
							max: pageRange.max,
							sortField: backingGrid.currentSortField ? backingGrid.currentSortField : 'beginDts',
							sortOrder: backingGrid.currentSortDirection	? backingGrid.currentSortDirection : 'ASC',
							status: ElementUtil.query(tripsheetGrid.toolbarFilter, 'status').value,	
							start:  startFilterDts,														
							end: endFilterDts,
							filterField: 'tractorId',
							filterValue: ElementUtil.query(tripsheetGrid.toolbarFilter, 'filterTractorId').value, 
							dateField: 'beginDts'
						};
																		
						var successHandler = function(records) {
							loadMask.remove();
							grid.activeItem = null;	
							grid.selectedItems = [];
														
							grid.items = records.data;

							pagingToolbar.totalRecords = records.totalNumber;
							pagingToolbar.updatePager();						
						};
						
						DataManagementService.getDistanceSummaryService().getTripSheets(grid.currentFilter).then(function(records){
							successHandler(records);
						});						
						
					};	
					
					loadData();														
				};
			},
			listeners: {
				ready: function() {					
					//pagingToolbar.loadCurrentPage();					
				}
			}
			
		});			
		
		var footerContainer = ElementUtil.create({
			tag: 'div',
			slot: 'footer',
			children: [
				exportToolbar,
				{
					tag: 'div',
					style: 'border-top: 1px solid lightgrey;'
				},
				pagingToolbar
			]
		});
		
		var flexLayout = ElementUtil.create({
			tag: 'dl-flex-layout',
			children: [
				toolbar,
				grid,
				footerContainer
			]
		});		
		tripsheetGrid.append(flexLayout);	

		tripsheetGrid.actionRefresh = function() {
			pagingToolbar.loadPage(1);
		};
		
		var actionAddEdit = function(record) {
			
			var addEditWin = ElementUtil.create({
				tag: 'dl-dialog',
				title: record ? 'Edit Trip Sheet' : 'Add Trip Sheet',
				icon: 'vaadin:edit',				
				width: 700,
				height: 460,
				listeners: {
					ready: function() {						
						addEditWin.show();
						
						
						var loadReferenceNo = function (refType, lookupValue, cbToPopulate, callback) {
							var paging = {
								max: 100
							};
							if (lookupValue) {
								paging.filterField = 'description';
								paging.filterValue = lookupValue;
							}
							UnitService.getUnitLookupService().getUnits(refType, paging).then(function (units) {
								cbToPopulate.items = units.data;
								if (callback) {
									callback(cbToPopulate);
								}
							});

						};
						
						var formPanel = ElementUtil.create({
							tag: 'dl-form-panel',
							itemid: 'form',
							children: [
								{
									tag: 'vaadin-form-layout',										
									children: [										
										{
											tag: 'vaadin-combo-box',
											itemid: 'tractorId',
											label: 'Tractor',
											name: 'tractorId',
											'item-value-path': 'code',
											'item-label-path': 'description',
											required: true,											
											postinit: function (combo) {												
											},
											listeners: {
												input: {
													fn: function (e) {
														var refNoCB = ElementUtil.query(formPanel, 'tractorId');
														loadReferenceNo('TRACTOR', ElementUtil.resolveComboInputValue(e, refNoCB), refNoCB);															
													},
													buffer: 500
												}
											}
										},
										{
											tag: 'vaadin-combo-box',	
											itemId: 'entryType',
											label: 'Entry Type',
											name: 'tripSheetEntryType',
											'item-value-path': 'code',
											'item-label-path': 'description',											
											value: 'M',
											postinit: function (combo) {
												Service.getLookupService().getLookupValues('TripSheetEntryType').then(function (data) {
													combo.items = data;
													combo.required = true;
												});
											},
											listeners: {
												change: function() {
													var entryTypeCB = ElementUtil.query(formPanel, 'entryType');
													var odometerField = ElementUtil.query(formPanel, 'odometer');
													
													if (entryTypeCB.value === 'O') {														
														ElementUtil.query(formPanel, 'odometer').disabled = false;
														odometerField.required = true;
													} else {
														ElementUtil.query(formPanel, 'odometer').disabled = true;
														odometerField.required = false;
													}
												}
											}
										},
										{
											tag: 'vaadin-number-field',												
											name: 'tripSheetRefNo',
											label: 'Trip Reference No',
											required: true,
											maxLength: 80
										},
										{
											tag: 'vaadin-combo-box',
											itemid: 'driverId',
											label: 'Driver',
											name: 'driverId',
											'item-value-path': 'code',
											'item-label-path': 'description',																				
											postinit: function (combo) {												
											},
											listeners: {
												input: {
													fn: function (e) {
														var refNoCB = ElementUtil.query(formPanel, 'driverId');
														loadReferenceNo('DRIVER', ElementUtil.resolveComboInputValue(e, refNoCB), refNoCB);															
													},
													buffer: 500
												}
											}
										},
										{
											tag: 'vaadin-date-time-picker',
											itemId: 'beginDate',
											label: 'Begin Date(mm/dd/yyyy hh:mm:ss)',
											name: 'beginDts',
											step: 1,
											required: true,	
											max: TimeUtil.formatDateForDateLoad(new Date()) + 'T23:59:59',
											listeners: {
												change: function(e) {
													var startDts = ElementUtil.query(formPanel, 'beginDate').value;
													ElementUtil.query(formPanel, 'endDate').min = startDts;
												}
											}
										},
										{
											tag: 'vaadin-date-time-picker',
											itemId: 'endDate',
											label: 'End Date(mm/dd/yyyy hh:mm:ss)',
											name: 'endDts',
											step: 1,
											min: TimeUtil.formatDateForDateLoad(new Date()) + 'T00:00:00',
											value: TimeUtil.formatDateForDateLoad(new Date()) + 'T23:59:59',
											required: true,
											listeners: {
												change: function(e) {
													var endDate = ElementUtil.query(formPanel, 'endDate').value;
													ElementUtil.query(formPanel, 'beginDate').max = endDate;
												}
											}
										},
										{
											tag: 'vaadin-combo-box',
											itemid: 'timezoneCB',
											label: 'TimeZone',
											name: 'timezone',
											'item-value-path': 'code',
											'item-label-path': 'description',
											value: TimeUtil.getCompanyTimeZoneNameOnly(),
											postinit: function (combo) {
												Service.getLookupService().getLookupValues('TimeZone').then(function (data) {
													combo.items = data;
												});
											}											
										},										
										{
											tag: 'vaadin-number-field',
											itemId: 'odometer',												
											name: 'initialOdometer',
											label: 'Initial Odometer',
											min: -9999999,
											max: 9999999
										},
										{
											tag: 'vaadin-combo-box',
											itemid: 'uomCB',
											label: 'UOM',
											name: 'distanceUom',
											'item-value-path': 'code',
											'item-label-path': 'description',											
											value: 'MI',
											postinit: function (combo) {
												Service.getLookupService().getLookupValues('DistanceUOM').then(function (data) {
													combo.items = data;
													combo.required = true;
												});
											}
										},																					
										{
											tag: 'hr',
											colspan: 2
										},
										{
											tag: 'div',
											style: 'text-align: center;',
											colspan: 2,
											defaults: {
												tag: 'vaadin-button'
											},
											children: [
												{
													theme: 'primary',
													children: [
														ElementUtil.makeIcon('vaadin:database', ' Save')
													],
													listeners: {
														click: function() {															
															
															var timezone = ElementUtil.query(formPanel, 'timezoneCB').value;
															formPanel.submitForm({
																timezone: timezone,
																preSubmit: function(data) {																																																
																	return data;
																},
																actualCall: function(data) {			
																	if (record) {
																		data.tripSheetId = record.tripSheetId;																		
																	} 																	
																	
																	return DataManagementService.getDistanceSummaryService().saveTripSheet(data, (record ? true : false));
																},
																success: function(data, responseData) {
																	window.DL.MessageUtil.showToast('Success', 'Saved Trip Sheet', {
																		theme: 'success',
																		position: 'top-stretch'
																	});
																	tripsheetGrid.actionRefresh();
																	addEditWin.close();
																}
															});															
															
														}
													}
												},
												{
													theme: 'tertiary',
													innerHTML: 'Cancel',
													style: 'margin-left: 10px;',
													listeners: {
														click: function() {
															//cancel
															addEditWin.close();
														}
													}
												}
											]
										}
									]
								}
							]
						});			
						
						addEditWin.addToContentElement(formPanel);
						
						setTimeout(function(){							
							ElementUtil.query(formPanel, 'odometer').disabled = true;
						});						
						
						var updateTractorCB = function() {
							var tractorIdFilter = ElementUtil.query(tripsheetGrid.toolbarFilter, 'filterTractorId').selectedItem;
							var initialValue = null;
							if (tractorIdFilter) {
								initialValue = tractorIdFilter.description;
							}
							var refNoCB = ElementUtil.query(formPanel, 'tractorId');	
							loadReferenceNo('TRACTOR', initialValue, refNoCB, function(cb) {
								if (tractorIdFilter) { 
									refNoCB.value = tractorIdFilter.code;
								}
							});
						};
						
						var updateDriverCB = function(refNo) {
							var refNoCB = ElementUtil.query(formPanel, 'driverId');	
							loadReferenceNo('DRIVER', refNo, refNoCB, function(cb) {	
								if (refNo) {
									refNoCB.value = record.driverId;
								}
							});
						};
						
						if (record) {								
							//wait for render;shift to end of event loop
							setTimeout(function() {
								formPanel.load(record);																							
								updateTractorCB();
								updateDriverCB(record.driverRefNo);
							});
						} else {
							updateTractorCB();
							updateDriverCB();
						}
					}
				}
			});	
			
			
		};
		
		var actionDelete = function(record) {
			
			window.DL.MessageUtil.showConfirm({
				title: 'Confirm Delete',
				message: '<b>Are you sure you want to delete "' + record.tripSheetRefNo + '" trip sheet?</b>',
				buttons: [
					{
						text: 'Yes',
						handler: function() {
							var loadMask = grid.showLoading('Removing...');

							DataManagementService.getDistanceSummaryService().deleteTripSheet(record.tripSheetId)
							.then(function(){
								loadMask.remove();
								window.DL.MessageUtil.showToast('Success', 'Removed '+ record.tripSheetRefNo, {									
									theme: 'success'
								});
								tripsheetGrid.actionRefresh();
							});						
						}
					},
					{
						text: 'No'
					}
				]
			});			
			
		};
		
		var actionDetails = function(record) {
			
			var detailsWin = ElementUtil.create({
				tag: 'dl-dialog',
				title: 'Details',
				icon: 'vaadin:notebook',				
				width: .75,
				height: .75,
				listeners: {
					ready: function() {						
						detailsWin.show();
				
						var detailToolbar = ElementUtil.create({
							tag: 'dl-toolbar',
							slot: 'toolbar',
							theme: 'spacing',
							children: [
								{
									tag: 'dl-action-button',
									itemid: 'add',
									theme: 'primary',
									'class': 'spacer-toolbar-item',					
									permissions: ['TRIP_SHEETS:WRITE'],
									children:[
										ElementUtil.makeIcon('vaadin:plus', ' Add')						
									],
									listeners: {
										click: function() {
											actionAddEditDetails();
										}
									}					
								},
								{
									tag: 'dl-action-button',
									itemid: 'edit',
									'class': 'spacer-toolbar-item',
									disabled: true,	
									permissions: ['TRIP_SHEETS:WRITE'],
									children:[
										ElementUtil.makeIcon('vaadin:edit', ' Edit')						
									],
									listeners: {
										click: function() {
											actionAddEditDetails(detailGrid.selectedItems[0]);
										}
									}					
								},
								{
									tag: 'dl-action-button',
									itemid: 'preview',
									'class': 'spacer-toolbar-item',									
									permissions: ['TRIP_SHEETS:WRITE'],
									children:[
										ElementUtil.makeIcon('vaadin:records', ' Preview')						
									],
									listeners: {
										click: function() {
											actionShowPreview();
										}
									}					
								},															
								{
									tag: 'div',
									style: 'float: right;',
									children:[											
										{
											tag: 'dl-action-button',
											itemid: 'delete',
											disabled: true,
											theme: 'error primary',
											'class': 'spacer-toolbar-item',					
											permissions: ['TRIP_SHEETS:DELETE'],							
											children:[
												ElementUtil.makeIcon('vaadin:trash', 'Remove')						
											],
											listeners: {
												click: function() {
													actionRemoveDetail(detailGrid.selectedItems[0]);
												}
											}							
										}
									]
								}											
							]
						});
						
						var detailGrid = ElementUtil.create({
							tag: 'vaadin-grid',
							theme: 'wrap-cell-content row-stripes column-borders',
							'column-reordering-allowed': '',
							style: 'height: 100%;',
							slot: 'primary',							
							defaults: {
								tag: 'vaadin-grid-sort-column',
								resizable: true,
								listeners: {
									'direction-changed': function (event) {
										if (event.detail && event.detail.value) {
											detailGrid.currentSortField = event.target.path;
											detailGrid.currentSortDirection = event.detail.value.toUpperCase();										
										}
									}
								}
							},
							children: [
								{						
									path: 'recordDts',
									header: 'Date',
									width: '7em',					
									renderer: function(root, column, rowData) {
										if (rowData.item.recordDts) {
											var date = TimeUtil.parseDate(rowData.item.recordDts);												
											root.innerHTML = TimeUtil.formatDateStandard(date);						
										}
									}
								},								
								{
									path: 'stateProvCode',
									header: 'State',
									width: '7em'
								},
								{
									path: 'countryCode',
									header: 'Country',
									width: '7em'
								},
								{
									path: 'distance',
									header: 'Distance',
									width: '7em'
								},
								{
									path: 'tollDistance',
									header: 'Toll Distance',
									width: '7em'
								},
								{
									path: 'ferryDistance',
									header: 'Ferry Distance',
									width: '7em'
								},
								{
									path: 'odometer',
									header: 'Odometer',
									width: '7em'
								}
							],
							listeners: {
								'active-item-changed': function (event) {
									const item = event.detail.value;
									detailGrid.selectedItems = item ? [item] : [];		
									
									if (detailGrid.selectedItems.length > 0) {
										ElementUtil.query(detailToolbar, 'edit').disabled = false;
										ElementUtil.query(detailToolbar, 'delete').disabled = false;
									} else {
										ElementUtil.query(detailToolbar, 'edit').disabled = true;
										ElementUtil.query(detailToolbar, 'delete').disabled = true;
									}									
								}
							}
						});
						
						var detailsFlexLayout = ElementUtil.create({
							tag: 'dl-flex-layout',
							children: [
								detailToolbar,
								detailGrid
							]
						});
						detailsWin.addToContentElement(detailsFlexLayout);
						
						var actionDetailsRefresh = function() {
							
							var loadMask = detailGrid.showLoading();
							DataManagementService.getDistanceSummaryService().getTripSheetDetails(record.tripSheetId).then(function(data){
								loadMask.remove();
								detailGrid.activeItem = null;	
								detailGrid.items = data;
							});
														
						};
						actionDetailsRefresh();
						
						var actionAddEditDetails = function(detail) {
							
							var addEditDetailWin = ElementUtil.create({
								tag: 'dl-dialog',
								title: detail ? 'Edit Detail' : 'Add Detail',
								icon: 'vaadin:edit',
								width: 700,
								height: 400,
								listeners: {
									ready: function () {
										addEditDetailWin.show();

										var formPanel = ElementUtil.create({
											tag: 'dl-form-panel',
											itemid: 'form',
											children: [
												{
													tag: 'vaadin-form-layout',
													children: [	
														{
															tag: 'vaadin-combo-box',
															itemid: 'stateProvCodeCB',
															label: 'State/Providence',
															name: 'stateProvCode',
															'item-value-path': 'code',
															'item-label-path': 'description',
															required: true,
															postinit: function (combo) {
																Service.getLookupService().getLookupValues('StateProvCode').then(function (data) {
																	combo.items = data;
																});
															}
														},
														{
															tag: 'vaadin-date-time-picker',
															label: 'Date(mm/dd/yyyy hh:mm:ss)',
															name: 'recordDts',
															step: 1,
															value: TimeUtil.formatDateForDateLoad(record.beginDts) + 'T00:00:00',
															min: TimeUtil.formatDateForDateLoad(record.beginDts) + 'T00:00:00',
															max: TimeUtil.formatDateForDateLoad(record.endDts) + 'T23:59:59',
															required: true
														},
														{
															tag: 'vaadin-number-field',
															itemId: 'odometer',
															'class': (record.tripSheetEntryType === 'O' ? '' : 'hide'),
															name: 'odometer',
															label: 'Odometer',
															min: -99999999,
															max: 99999999
														},
														{
															tag: 'vaadin-number-field',
															itemId: 'distance',
															'class': (record.tripSheetEntryType === 'O' ? 'hide' : ''),
															name: 'distance',
															label: 'Distance',
															min: -9999999,
															max: 9999999
														},
														{
															tag: 'vaadin-number-field',
															itemId: 'tollDistance',
															'class': (record.tripSheetEntryType === 'O' ? 'hide' : ''),
															name: 'tollDistance',
															label: 'Toll Distance',
															value: 0,
															min: -9999999,
															max: 9999999
														},
														{
															tag: 'vaadin-number-field',
															itemId: 'ferryDistance',
															'class': (record.tripSheetEntryType === 'O' ? 'hide' : ''),
															name: 'ferryDistance',
															label: 'Ferry Distance',
															value: 0,
															min: -9999999,
															max: 9999999
														},																												
														{
															tag: 'hr',
															colspan: 2
														},
														{
															tag: 'div',
															style: 'text-align: center;',
															colspan: 2,
															defaults: {
																tag: 'vaadin-button'
															},
															children: [
																{
																	theme: 'primary',
																	children: [
																		ElementUtil.makeIcon('vaadin:database', ' Save')
																	],
																	listeners: {
																		click: function () {

																			formPanel.submitForm({
																				preSubmit: function (data) {
																					data.countryCode = ElementUtil.query(formPanel, 'stateProvCodeCB').selectedItem.country;
																					data.tripSheetId = record.tripSheetId;
																					data.tractorId = record.tractorId;
																					data.tripSheetEntryType = record.tripSheetEntryType;
																					
																					return data;
																				},
																				actualCall: function (data) {
																					if (detail) {																						
																						data.tripSheetDetailId = detail.tripSheetDetailId;
																					}

																					return DataManagementService.getDistanceSummaryService().saveTripSheetDetail(data, (detail ? true : false));
																				},
																				success: function (data, responseData) {
																					window.DL.MessageUtil.showToast('Success', 'Saved Trip Sheet Detail', {
																						theme: 'success',
																						position: 'top-stretch'
																					});
																					actionDetailsRefresh();
																					addEditDetailWin.close();
																				}
																			});

																		}
																	}
																},
																{
																	theme: 'tertiary',
																	innerHTML: 'Cancel',
																	style: 'margin-left: 10px;',
																	listeners: {
																		click: function () {
																			//cancel
																			addEditDetailWin.close();
																		}
																	}
																}
															]
														}
													]
												}
											]
										});

										addEditDetailWin.addToContentElement(formPanel);

										if (detail) {
											formPanel.load(detail);											
										} 
										
										//wait for render;shift to end of event loop
										setTimeout(function () {

											//switch required flags
											if (record.tripSheetEntryType === 'O') {
												ElementUtil.query(formPanel, 'odometer').required = true;
												ElementUtil.query(formPanel, 'distance').required = false;
												ElementUtil.query(formPanel, 'tollDistance').required = false;
												ElementUtil.query(formPanel, 'ferryDistance').required = false;
											} else {
												ElementUtil.query(formPanel, 'odometer').required = false;
												ElementUtil.query(formPanel, 'distance').required = true;
												ElementUtil.query(formPanel, 'tollDistance').required = true;
												ElementUtil.query(formPanel, 'ferryDistance').required = true;
											}

										});
										
									}
								}
							});	
							
						};
						
						var actionRemoveDetail = function(detail) {
							
							window.DL.MessageUtil.showConfirm({
								title: 'Confirm Delete',
								message: '<b>Are you sure you want to delete selected detail?</b>',
								buttons: [
									{
										text: 'Yes',
										handler: function() {
											var loadMask = detailGrid.showLoading('Removing...');

											DataManagementService.getDistanceSummaryService().deleteTripSheetDetail(record.tripSheetId, detail.tripSheetDetailId)
											.then(function(){
												loadMask.remove();
												window.DL.MessageUtil.showToast('Success', 'Removed Detail ', {									
													theme: 'success'
												});
												actionDetailsRefresh();
											});						
										}
									},
									{
										text: 'No'
									}
								]
							});								
							
						};
						
						var actionShowPreview = function() {
							
							var previewWin = ElementUtil.create({
								tag: 'dl-dialog',
								title: 'Preview',
								icon: 'vaadin:notebook',
								width: .65,
								height: .65,
								listeners: {
									ready: function() {
										previewWin.show();
								
										var previewToolbar = ElementUtil.create({
											tag: 'dl-toolbar',
											slot: 'toolbar',
											theme: 'spacing',
											children: [
												{
													tag: 'dl-action-button',
													itemid: 'complete',
													theme: 'primary',
													'class': 'spacer-toolbar-item',
													permissions: ['TRIP_SHEETS:WRITE'],
													children: [
														ElementUtil.makeIcon('vaadin:check', ' Complete')
													],
													listeners: {
														click: function () {
															actionComplete();
														}
													}
												}												
											]
										});

										var previewGrid = ElementUtil.create({
											tag: 'vaadin-grid',
											theme: 'wrap-cell-content row-stripes column-borders',
											'column-reordering-allowed': '',
											style: 'height: 100%;',
											slot: 'primary',
											defaults: {
												tag: 'vaadin-grid-sort-column',
												resizable: true,
												listeners: {
													'direction-changed': function (event) {
														if (event.detail && event.detail.value) {
															previewGrid.currentSortField = event.target.path;
															previewGrid.currentSortDirection = event.detail.value.toUpperCase();
														}
													}
												}
											},
											children: [
												{
													path: 'periodEndUtcDts',
													header: 'Date',
													width: '7em',
													renderer: function (root, column, rowData) {
														if (rowData.item.periodEndUtcDts) {
															var date = TimeUtil.parseDate(rowData.item.periodEndUtcDts);
															root.innerHTML = TimeUtil.formatDateStandard(date);
														}
													}
												},
												{
													path: 'stateProvCode',
													header: 'State',
													width: '7em'
												},
												{
													path: 'countryCode',
													header: 'Country',
													width: '7em'
												},
												{
													path: 'travelDistance',
													header: 'Distance',
													width: '7em'
												},
												{
													path: 'tollDistance',
													header: 'Toll Distance',
													width: '7em'
												},
												{
													path: 'ferryDistance',
													header: 'Ferry Distance',
													width: '7em'
												},
												{
													path: 'odometer',
													header: 'Odometer',
													width: '7em'
												}
											],
											listeners: {
												'active-item-changed': function (event) {
													const item = event.detail.value;
													previewGrid.selectedItems = item ? [item] : [];
													
												}
											}
										});

										var previewFlexLayout = ElementUtil.create({
											tag: 'dl-flex-layout',
											children: [
												previewToolbar,
												previewGrid
											]
										});
										previewWin.addToContentElement(previewFlexLayout);

										var actionPreview = function () {

											var loadMask = previewGrid.showLoading();
											DataManagementService.getDistanceSummaryService().getTripSheetPreview(record.tripSheetId).then(function (data) {
												loadMask.remove();
												previewGrid.activeItem = null;
												previewGrid.items = data;
											});

										};
										actionPreview();
									
										var actionComplete = function () {

											window.DL.MessageUtil.showConfirm({
												title: 'Confirm Completion',
												message: '<b>Are you sure you want to complete this trip sheet?</b><br>This will generate distance summaries and mark the trip sheet complete.',
												buttons: [
													{
														text: 'Yes',
														handler: function() {
															var loadMask = detailGrid.showLoading('Completing...');

															DataManagementService.getDistanceSummaryService().completeTripSheet(record.tripSheetId)
															.then(function(){
																loadMask.remove();
																window.DL.MessageUtil.showToast('Success', 'Completed Trip Sheet ', {									
																	theme: 'success'
																});
																detailsWin.close();
																previewWin.close();
																tripsheetGrid.actionRefresh();
																															
																
																var readyEvent = new CustomEvent('complete', { detail: '' });
																tripsheetGrid.dispatchEvent(readyEvent);
																
															});						
														}
													},
													{
														text: 'No'
													}
												]
											});	
									
										};
									
									}
								}
							});
							
							
							
							
						};

					}
				}
			});
						
		};

	}
	
	refreshGrid() {
		var tripsheetGrid = this;		
		tripsheetGrid.actionRefresh();
	}
	
	setFilterContainer(filterContainer) {
		var tripsheetGrid = this;		
		tripsheetGrid.toolbarFilter = filterContainer;
	}	
	
	
}
customElements.define('dl-tripsheet-grid', TripSheetGrid);


